import InvoiceReports from "./reports_filters/reports_comps/InvoiceReports.jsx";
import PurchaseReports from "./reports_filters/reports_comps/PurchaseReports.jsx";
import CRMReports from "./reports_filters/reports_comps/CRMReports.jsx";
import ServiceReports from "./reports_filters/reports_comps/ServiceReports.jsx";
import ProductionReports from "./reports_filters/reports_comps/ProductionReports.jsx";
import ContactReports from "./reports_filters/reports_comps/ContactReports.jsx";
import FinancialInventoryReports from "./reports_filters/reports_comps/FinancialInventoryReports.jsx";
import { useState } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./reportsMain.css";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as Action from "../../../../store/redux/client_reducer.js";
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>


import IsLoading from "../../../../IsLoading.jsx";
import FilterDiscount from "./reports_filters/ReportsFilters.jsx";
import ExportPDFButton from "./reports_exportations/ReportsPDFExport.jsx";
import ExportExcelJSButton from "./reports_exportations/ReportsExcelExport.jsx";
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

// import from MUI
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PrintIcon from "@mui/icons-material/Print";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import FlightIcon from "@mui/icons-material/Flight";
import PlaceIcon from "@mui/icons-material/Place";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import AddIcon from "@mui/icons-material/Add";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
// image imports
import ImgOne from "./img1.jpg";
import ImgTwo from "./img2.jpg";
import ProductReports from "./reports_filters/reports_comps/ProductsReports.jsx";
import SalesBasedReports from "./reports_filters/reports_comps/Sales-Based-Reports.jsx";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PeopleIcon from "@mui/icons-material/People";
import BuildIcon from "@mui/icons-material/Build";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import ContactsIcon from "@mui/icons-material/Contacts";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import StorefrontIcon from "@mui/icons-material/Storefront";

export default function ReportsMain({ breadcrumbs }) {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [changeview, setChangeView] = useState("");
  const [reportsmainFilterOpen, setreportsmainFilterOpen] = useState(false);

  // Paginations Functions
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openLimit, setOpenLimit] = useState(false);


  const currentTab = useSelector(
    (state) => state.clientFunction?.dashboard?.currentTab,
  );

  // The sidebar uses "reports_main" for the overview. Only show the return
  // action when an individual report is actually selected.
  const isIndividualReport = [
    "invoices-report",
    "purchases-report",
    "sales-base-report",
    "crm-report",
    "services-report",
    "production-report",
    "contacts-report",
    "financial-report",
    "product-report",
  ].includes(currentTab);

  // /////////////////////////////////////////////////////////
  // Redux functions for sub-navigation
  // /////////////////////////////////////////////////////////
  function handleCurrentTAB(item) {
    dispatch(DispatchCurrentTAB(item));
  }
  const DispatchCurrentTAB = (item) => async (dispatch) => {
    try {
      dispatch(Action.dispatchCurrentTAB({ item }));
    } catch (error) {
      console.log(error?.code || "REQUEST_FAILED");
    }
  };
  const DispatchPrinting = (data) => async (dispatch) => {
    try {
      dispatch(Action.dispatchPrintData({ data }));
    } catch (error) {
      console.log(error?.code || "REQUEST_FAILED");
    }
  };

  // ////////////////////////////////////////////////////////////
  function getPagination(current, total) {
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    if (current <= 4) {
      return [1, 2, 3, 4, 5, "...", total];
    }

    if (current >= total - 3) {
      return [1, "...", total - 4, total - 3, total - 2, total - 1, total];
    }

    return [1, "...", current - 1, current, current + 1, "...", total];
  }

  function switchActiveTab() {
    switch (currentTab) {
case "invoices-report":return <InvoiceReports/>;
case "purchases-report":return <PurchaseReports/>;
case "crm-report":return <CRMReports/>;
case "services-report":return <ServiceReports/>;
case "production-report":return <ProductionReports/>;
case "contacts-report":return <ContactReports/>;
case "financial-report":return <FinancialInventoryReports/>;

      case "reportsmain":
        return <MainPage />;
      case "product-report":
        return <ProductReports />;
      case "sales-base-report":
        return <SalesBasedReports />;
      default:
        return <MainPage />;
    }
  }

  // //////////////////////////////////////////////////////////////////////////
  // COMPONENTS OF reportsmain PAGE
  // //////////////////////////////////////////////////////////////////////////
  const reportCards = [
    {
      title: "Invoices",
      onClick:()=>handleCurrentTAB("invoices-report"),
      icon: ReceiptLongIcon,
      amount: "Live Data",
      duration: "/Saved records",
      description: "Monitor invoices, payments, and overdue balances.",
      button: "Explore Report",
      features: [
        "Invoice Summary",
        "Outstanding Bills",
        "Tax Reports",
        "Payment History",
      ],
    },
    {
      title: "Purchases",
      onClick:()=>handleCurrentTAB("purchases-report"),
      icon: ShoppingCartIcon,
      amount: "Vendor Hub",
      duration: "/Saved records",
      description: "Track purchases, suppliers, and procurement costs.",
      button: "Explore Report",
      features: [
        "Purchase Orders",
        "Supplier Analysis",
        "Cost Tracking",
        "Receiving Logs",
      ],
    },
    {
      title: "Sales-Based Reports",
      icon: PointOfSaleIcon,
      amount: "Revenue Hub",
      duration: "/Saved records",
      description: "Analyze sales, revenue, and product performance.",
      button: "View Dashboard",
      onClick: () => handleCurrentTAB("sales-base-report"),
      features: [
        "Sales Trends",
        "Revenue Insights",
        "Top Products",
        "Recorded Sale Costs",
      ],
    },
    {
      title: "CRM Reports",
      onClick:()=>handleCurrentTAB("crm-report"),
      icon: PeopleIcon,
      amount: "Client Hub",
      duration: "/Saved records",
      description:
        "Customer Relationship Management, retention, and engagement metrics.",
      button: "Explore CRM",
      features: [
        "Customer Insights",
        "Repeat Customers",
        "Identified Sales",
        "Customer Value",
      ],
    },
    {
      title: "Services ",
      onClick:()=>handleCurrentTAB("services-report"),
      icon: BuildIcon,
      amount: "Service Ops",
      duration: "/Saved records",
      description: "Monitor services, requests, and technician output.",
      button: "Explore Services",
      features: [
        "Service Requests",
        "Recorded Operators",
        "Service Revenue",
        "Completed Units",
      ],
    },
    {
      title: "Productions",
      onClick:()=>handleCurrentTAB("production-report"),
      icon: PrecisionManufacturingIcon,
      amount: "Factory Hub",
      duration: "/Saved records",
      description: "Track production, materials, and factory output.",
      button: "View Production",
      features: [
        "Production Output",
        "Material Usage",
        "Production Costs",
        "Stock Posting",
      ],
    },
    {
      title: "Contacts ",
      onClick:()=>handleCurrentTAB("contacts-report"),
      icon: ContactsIcon,
      amount: "Directory",
      duration: "/Saved records",
      description: "Manage suppliers, customers, and business contacts.",
      button: "Explore Contacts",
      features: [
        "Supplier List",
        "Customer Directory",
        "Contact History",
        "Saved Contact Details",
      ],
    },
    {
      title: "Financial Inventory ",
      onClick:()=>handleCurrentTAB("financial-report"),
      icon: Inventory2Icon,
      amount: "Finance Hub",
      duration: "/Saved records",
      description: "Review inventory value, costs, and stock movement.",
      button: "Financial Reports",
      features: [
        "Inventory Value",
        "Stock Movement",
        "Recorded Costs",
        "Return Credits",
      ],
    },
    {
      title: "Stocks",
      icon: StorefrontIcon,
      amount: "Stock Hub",
      duration: "/Current snapshot",
      description: "Track stock levels, transfers, and reorder alerts.",
      button: "View Inventory",
      onClick: () => handleCurrentTAB("product-report"),
      features: [
        "Stock Levels",
        "Low Stock Alerts",
        "Warehouse Transfer",
        "Stock Adjustments",
      ],
    },
  ];
  function MainPage() {
    return (
      <div className="fx-cl space2">
        {loading ? (
          <IsLoading />
        ) : (
          <div className="fx-cl space2">
            <div className="fx-cl spacem">
              <div className="reportsmain_row" id="printable">
                <div className="reportsmainCardGrid g g4 space2">
                  {reportCards.map((card, index) => {
                    const Icon = card.icon;
                    return (
                      <figure className="reportsItemCard fx-cl" key={index}>
                        <div className="rptItemCardTop fx-cl space2">
                          <span className="fs3 fw500">
                            {" "}
                            {Icon && <Icon style={{ fontSize: "1.6rem" }} />}
                            {card.title}
                          </span>

                          <div className="fx-cl spacem">
                            <div className="fx-ac space1">
                              <h3 className="fs5 fw600 fx-ac space1">
                                {/* {Icon && (
                                  <Icon style={{ fontSize: "2.6rem" }} />
                                )} */}
                                <span>{card.amount}</span>
                              </h3>
                              <span className="fs1">{card.duration}</span>
                            </div>

                            <p className="fw500" style={{ fontSize: "1.4rem" }}>
                              {card.description}
                            </p>
                          </div>

                          <button onClick={card.onClick}>
                            {card.button || "Explore Report"}
                          </button>
                        </div>

                        <div className="rptItemCardBottom fx-cl spacem fs1">
                          {card.features.map((feature, i) => (
                            <div className="fx-ac spacem" key={i}>
                              <CheckCircleOutlinedIcon fontSize="large" />
                              <span>{feature}</span>
                            </div>
                          ))}
                        </div>
                      </figure>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="reportsmainCompContainer">
      <div className="fx-cl space2">
        <header className="reports-premium-header">
          <nav className="reports-premium-breadcrumb" aria-label="Reports breadcrumb">
            <span>Company Account</span>
            <KeyboardArrowRightIcon fontSize="small" aria-hidden="true" />
            {!isIndividualReport ? <strong>Reports</strong> : <>
              <button type="button" onClick={() => handleCurrentTAB('reportsmain')}>Reports</button>
              <KeyboardArrowRightIcon fontSize="small" aria-hidden="true" />
              <strong>{({ 'invoices-report':'Invoices', 'purchases-report':'Purchases',
                'sales-base-report':'Sales-Based Reports', 'crm-report':'CRM Reports',
                'services-report':'Services', 'production-report':'Productions',
                'contacts-report':'Contacts', 'financial-report':'Financial Inventory',
                'product-report':'Stocks' })[currentTab] || 'Reports'}</strong>
            </>}
          </nav>
          {!isIndividualReport ? <div className="reports-premium-intro">
            <span className="reports-premium-mark" aria-hidden="true"><CandlestickChartIcon /></span>
            <div><span className="reports-premium-eyebrow">BUSINESS INTELLIGENCE</span>
              <h1>Reports &amp; Analytics</h1>
              <p>Explore saved business activity, financial records, customers, stock, and operational performance.</p>
            </div>
          </div> : <div className="reports-premium-return">
            <button type="button" onClick={() => handleCurrentTAB('reportsmain')}>
              <span aria-hidden="true">←</span> Back to all reports
            </button>
          </div>}
        </header>
        <div className="reportsmain_main">{switchActiveTab()}</div>
      </div>
    </div>
  );
}
